export default __webpack_public_path__ + "static/media/placeholder_portfolio03-it-mobile.660fc524.png";